module.exports = __webpack_public_path__ + "static/img/3.63d11a7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/menthu/4/3.png
// module id = lqOz
// module chunks = 0